import { Text } from '@daily/shared/components/Text';
import { useTheme } from '@daily/shared/contexts/Theme';
import { DailyNetworkStats } from '@daily-co/daily-js';
import { memo, useMemo } from 'react';

interface Props {
  hasPoorConnection: boolean;
  isScreen: boolean;
  name: string;
  network?: DailyNetworkStats['threshold'];
}

export const NoVideo: React.FC<React.PropsWithChildren<Props>> = memo(
  ({ hasPoorConnection, isScreen, name, network }) => {
    const { colors } = useTheme();

    const noVideoText = useMemo(() => {
      let color: React.ComponentProps<typeof Text>['color'] = 'inherit';
      if (network === 'low') {
        color = 'warning';
      }
      if (hasPoorConnection) {
        color = 'error';
      }
      return (
        <Text color={color} truncate variant="strong">
          {name}
        </Text>
      );
    }, [hasPoorConnection, name, network]);

    return (
      <div className="noVideo">
        {isScreen ? null : noVideoText}
        <style jsx>{`
          .noVideo {
            background-color: ${colors.custom.mainAreaBgAccent};
            color: ${colors.custom.mainAreaText};
            left: 50%;
            max-width: 100%;
            padding: 0 16px;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        `}</style>
      </div>
    );
  }
);
NoVideo.displayName = 'NoVideo';
